import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { NewLogisticProvidersFormBody, PatchLogisticProvidersFormBody } from '@/api/apis/facilities';
import { queryClient } from '@/queries';
import { partnerProvidersQueries } from '@/queries/partner-providers';
import { partnerProvidersQueryKeys } from '@/queries/partner-providers/partner-providers.keys';

type RemoveLogisticProviderMutationVars = {
  id: string;
};

export const useRemovePartnerProviderMutation = () => {
  return useMutation({
    mutationFn: (variables: RemoveLogisticProviderMutationVars) =>
      api.partnerprovider.removePartnerProviderById(variables.id),
    meta: {
      invalidates: [partnerProvidersQueryKeys.getList()],
    },
  });
};

export const useCreatePartnerProviderMutation = () => {
  return useMutation({
    mutationFn: (variables: NewLogisticProvidersFormBody & { id: string }) =>
      api.partnerprovider.createPartnerProvider(variables),
    meta: {
      invalidates: [partnerProvidersQueryKeys.getList()],
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(partnerProvidersQueries.item(variables.id).queryKey, data);
    },
  });
};

export const useUpdatePartnerProviderMutation = () => {
  return useMutation({
    mutationFn: (variables: PatchLogisticProvidersFormBody & { id: string }) =>
      api.partnerprovider.updatePartnerProviderById(variables),
    meta: {
      invalidates: [partnerProvidersQueryKeys.getList()],
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(partnerProvidersQueries.item(variables.id).queryKey, data);
    },
  });
};
